import { useAuth } from "../auth/useAuth";
import { isMultiplayer } from "../lib/gameMeta";
import type { GameDetail } from "../lib/types";

// Guest-play nudge for multiplayer games: play signed-out, but signing in carries
// your identity + rating across every game. Ported from mountMultiplayerNudge().
export function MultiplayerNudge({ game }: { game: GameDetail }) {
  const { account, openAuth } = useAuth();
  if (!isMultiplayer(game)) return null;

  if (account) {
    return (
      <div className="mp-nudge is-signed-in" id="mpNudge">
        <span className="mp-nudge-dot" aria-hidden="true" />
        <p className="mp-nudge-text">
          Signed in as {account.username} — your wins and rating are saved across reArcade.
        </p>
      </div>
    );
  }
  return (
    <div className="mp-nudge" id="mpNudge">
      <p className="mp-nudge-text">
        Online multiplayer. Play as a guest, or{" "}
        <button type="button" className="mp-nudge-cta" onClick={() => openAuth("signin")}>
          Sign in
        </button>{" "}
        to save your wins and rating across every game.
      </p>
    </div>
  );
}
